import React, { useLayoutEffect, useRef } from 'react';

import { Input } from 'design-system';

import { formatAmountInput } from '../../filterParams';
import { AmountFieldWrap, AmountPrefix } from './styles';

const AMOUNT_FILTER_INPUT_ID = 'notas-amount-filter';

export type AmountFilterFieldProps = {
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

const AmountFilterField = ({
  value,
  onChange,
  onFocus,
  onBlur,
}: AmountFilterFieldProps): JSX.Element => {
  const shouldMoveCaretRef = useRef(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    shouldMoveCaretRef.current = true;
    onChange(formatAmountInput(event.target.value));
  };

  useLayoutEffect(() => {
    if (!shouldMoveCaretRef.current) return;

    const input = document.getElementById(
      AMOUNT_FILTER_INPUT_ID
    ) as HTMLInputElement | null;
    if (!input) return;

    const length = input.value.length;
    input.setSelectionRange(length, length);
    shouldMoveCaretRef.current = false;
  }, [value]);

  return (
    <AmountFieldWrap>
      <Input
        id={AMOUNT_FILTER_INPUT_ID}
        label="Valor"
        shape="pill"
        fullWidth
        inputMode="numeric"
        leadingIcon={<AmountPrefix>R$</AmountPrefix>}
        value={value}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </AmountFieldWrap>
  );
};

export default AmountFilterField;
